import { useState } from 'react'

import { customDelete, customPost } from '../utils/customFetch.ts'
import { Activity } from '../interfaces/DealDto.ts'
import { stringToMongoDateTime } from '../utils/utils.ts'

import { makeUrlActivityDelete, makeUrlActivityEdit } from './connectionData.tsx'
import { useAuth } from './useAuth.tsx'

const useDealActivityEdit = () => {
  const [errorActivityEdit, setErrorActivityEdit] = useState<Error | null>(null)
  const [loading, setLoading] = useState<boolean>(false)
  const { userData } = useAuth()

  const activityEdit = async (activity: Activity, modifica: boolean) => {
    setLoading(true)

    try {
      activity.profile = userData?.profile?._id ?? ''
      const id = await updateDatabase(activity, modifica)
      setErrorActivityEdit(null)

      return id
    } catch (err) {
      // Assert the error as an instance of Error
      if (err instanceof Error) {
        setErrorActivityEdit(err)
      } else {
        setErrorActivityEdit(new Error('An unknown error occurred'))
      }

      return null
    } finally {
      setLoading(false)
    }
  }
  const updateDatabase = async (activity: Activity, modifica: boolean): Promise<string> => {
    // El dato de la actividad puede venir sin el time zone, ya
    // que proviene de un datepicker.
    // Lo cambiamos aca
    const activityNew = { ...activity, date: stringToMongoDateTime(activity.date) }

    const apiUrl = makeUrlActivityEdit(modifica)

    const res = await customPost<{ _id: string }>(apiUrl, activityNew)

    return res._id
  }
  const activityDelete = async (activityId: string) => {
    setLoading(true)

    try {
      const apiUrl = makeUrlActivityDelete()
      await customDelete(apiUrl, { _id: activityId })
      setErrorActivityEdit(null)

      return 'OK'
    } catch (err) {
      // Assert the error as an instance of Error
      if (err instanceof Error) {
        setErrorActivityEdit(err)
      } else {
        setErrorActivityEdit(new Error('An unknown error occurred'))
      }

      return null
    } finally {
      setLoading(false)
    }
  }

  // Exponemos estas variables al exterior
  return { errorActivityEdit, loading, activityEdit, activityDelete }
}
export default useDealActivityEdit
